import { TriangleAlert } from "lucide-react";
import { RetryButton } from "../../retry/RetryButton";
import { cn } from "../../../../lib/utils";

interface ErrorDisplayV2Props {
    dangerBorder?: boolean;
    title?: string;
    className?: string;
    errorMessage: string;
    onRetry: () => void;
    allowRetry?: boolean;
}

const ErrorDisplayV2: React.FC<ErrorDisplayV2Props> = ({
    title,
    errorMessage = "We're sorry, something went wrong on our end. Please refresh the page or try again shortly.",
    className,
    dangerBorder = true,
    allowRetry = true,
    onRetry 
}) => {
    return (
        <div className={cn("mx-auto shadow-overviewCard p-8 rounded-lg", dangerBorder && "border border-red-500", className)}>
            <div className="flex flex-col items-center gap-2">
                <div className="text-center rounded-md border p-4 mb-4">
                    <TriangleAlert width={24} height={24} color="red"/>
                </div>
                <h3 className="font-semibold text-lg text-center">{title || "We're sorry, something went wrong on our end. Please refresh the page or try again shortly."}</h3>
                <p className="text-sm text-center text-muted-foreground">{errorMessage}</p>
                {allowRetry &&
                    <RetryButton
                        onClick={onRetry}
                        isLoading={false}
                        disabled={false}
                        version="2"
                    />
                }
            </div>
        </div>
    );
};

export default ErrorDisplayV2;